import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  personalBrandingIcon,
  seoMarketingIcon,
  socialMarketingIcon,
  payPerClickIcon,
  emailMarketinIcon,
  influencerMarketingIcon,
} from "../../../../assets/icons/serviceIcon/index";
import AnalyticWork from "./AnalyticWork";

const items = [
  {
    name: "Platform Insights & Reports",
    text: "We monitor your social and ad performance, then break it down into simple, easy-to-understand reports.",
  },
  {
    name: "Traffic & Conversion Tracking",
    text: "We set up tools to track how people are finding you and what makes them take action.",
  },
  {
    name: "Strategy Tweaks & Growth Moves",
    text: "We use real numbers to fine-tune your content, ads, and overall strategy for better results every month.",
  },
];

const otherService = [
  {
    icon: seoMarketingIcon,
    name: "Seo & Content Marketing",
    des: "Get ranked on Google and stay in hearts with content that truly speaks to your people.",
    path: "/seo-content-marketing",
  },
  {
    icon: socialMarketingIcon,
    name: "Social Media Marketing (SMM)",
    des: "Show up where your audience scrolls, shares and starts to trust you.",
    path: "/social-media-marketing",
  },
  {
    icon: payPerClickIcon,
    name: "Pay Per Click",
    des: "Get your brand seen by the right people, right when they’re searching for you.",
    path: "/pay-per-click",
  },
  {
    icon: emailMarketinIcon,
    name: "Email & CRM Marketing",
    des: "Stay in touch in a meaningful way with emails people actually want to open.",
    path: "/email-marketing",
  },
  {
    icon: influencerMarketingIcon,
    name: "Influencer & Affiliate Marketing",
    des: "Let others talk about your brand in a way that feels real and relatable.",
    path: "/influencer-marketing",
  },
  {
    icon: personalBrandingIcon,
    name: "personal Branding",
    des: "Turn your story, skills, and personality into something people remember and trust.",
    path: "/personal-branding",
  },
];

const Analytics = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Tracking"
        description="Marketing without data is just guessing. We track what’s working, what’s not and where to double down, so your brand grows smarter every day."
        heading="Analytics & Performance"
      />
      <NewCommonServiceForm
        title="Analytics  & Performance Tracking"
        items={items}
      />
      <AnalyticWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default Analytics;
